import type { JSX } from 'react';

const NotificationCenterEmptyState = (): JSX.Element => (
  <div
    className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border-default
      bg-bg-surface-alt px-6 py-14 text-center"
    role="status"
  >
    <p className="m-0 max-w-md text-sm text-text-muted font-body">
      No se encontró una inmobiliaria válida para el id seleccionado. Elige de nuevo en el selector del menú lateral.
    </p>
  </div>
);

export default NotificationCenterEmptyState;
